<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center" mt-5>
        <h1>Registriracija</h1>
        <p>Že imaš račun? <router-link to="login">Vpiši se</router-link>.</p>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 mt-3>
        <form @submit.prevent="register">
          <v-layout column>
            <v-flex>
              <v-text-field
                name="email"
                label="Email"
                id="email"
                type="email"
                v-model="email"
                required>
              </v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="password"
                label="Password"
                id="password"
                type="password"
                v-model="password"
                required>
              </v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="first_name"
                label="Ime"
                id="first_name"
                type="text"
                v-model="first_name"
                required>
              </v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="last_name"
                label="Priimek"
                id="last_name"
                type="text"
                v-model="last_name"
                required>
              </v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="phone"
                label="Telefon"
                id="phone"
                type="number"
                v-model="phone"
                required>
              </v-text-field>
            </v-flex>
            <v-flex class="text-xs-center" mt-5>
              <v-btn
                color="primary"
                type="submit">
                Registriraj se
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase';
import db from '../components/firebaseInit';

export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: '',
      first_name: '',
      last_name: '',
      phone: '',
    };
  },

  methods: {
    register() {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(
          (user) => {
            this.writeUser(user);
          },
          (err) => {
            console.log(err.message);
          },
        );
    },

    writeUser(user) {
      db
        .collection('users').doc(user.user.uid).set({
          email: this.email,
          first_name: this.first_name,
          last_name: this.last_name,
          phone: this.phone,
        })
        .then(
          () => {
            this.$router.go({ path: this.$router.path });
          },
          (err) => {
            console.log(err.message);
          },
        );
    },
  },
};
</script>
